import { Button, cn } from "@tellescope/ui";
import { TellescopeFormFieldBaseProps } from "../../types";
import { AddMedicationForm } from "./AddMedicationForm";
import { useTranslation } from "react-i18next";
import { MedicationResponse } from "@tellescope/types-models";

const EMPTY_MEDICATION: MedicationResponse = {
  displayTerm: "",
  drugName: "",
};

export interface MedicationsFieldProps extends TellescopeFormFieldBaseProps<"Medications"> {}

export const MedicationsField = ({ title, value, onChange, className, error }: MedicationsFieldProps) => {
  const { t } = useTranslation("forms");

  const normalizedMedications = value?.length ? value : [EMPTY_MEDICATION];

  return (
    <div className={cn("flex flex-col gap-2", className)}>
      {!!title && <h4>{title}</h4>}
      <>
        {normalizedMedications?.map((medication, i) => (
          <AddMedicationForm
            key={`new-medication-${medication.displayTerm}-${medication.drugName}-${i}`}
            medication={medication}
            onChange={(newMed) =>
              onChange(normalizedMedications.map((medication, j) => (i === j ? newMed : medication)))
            }
            onRemove={
              normalizedMedications.length === 1
                ? undefined
                : () => {
                    onChange([...normalizedMedications.slice(0, i), ...normalizedMedications.slice(i + 1)]);
                  }
            }
          />
        ))}
        <Button
          variant="secondary"
          onClick={() => {
            onChange([...(value ?? []), { displayTerm: "", drugName: "" }]);
          }}
        >
          {t("Add Medication")}
        </Button>
      </>
      {!!error && <p className="text-sm text-destructive mt-1">{error}</p>}
    </div>
  );
};
